var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config"},[_c('UploaderElementUi',{attrs:{"element":_vm.element,"image":_vm.element.config.url ? _vm.element.config.url : ''},on:{"changeConfig":_vm.changeConfig}}),_c('NumberInput',{attrs:{"element":_vm.element,"zIndex":_vm.element.config.zIndex ? _vm.element.config.zIndex : ''},on:{"changeConfig":_vm.changeConfig}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }